export default {"src":"/_next/static/media/fresh-badge.2896a98a.svg","height":103,"width":102,"blurWidth":0,"blurHeight":0};